import type { ConfigProviderThemeVars } from 'vant'

export const vanThemeVars: ConfigProviderThemeVars = {
  tabbarHeight: '56px',
  tabbarBackground: '--van-gray-5',
}
